<template>
    <section id="banner">
        <video-bg :sources="[videomp4]" :img="videoimage"></video-bg>

        <div class="body">
            <div class="conteudo">
                <img class="logo-sm" :src="[imageSm2019]"/>
                <p class="titulo">24 a 27 DE SETEMBRO</p>
                <div class="atracoes">
                    <div>
                        <p><b>ATRAÇÕES CONFIRMADAS:</b><br>João Sabiá, Banda Milênio, Banda Expresso Musical, Grupo Chega Mais</p>
                    </div>
                    <div>
                        <p><b>CONVIDADOS ESPECIAIS:</b><br>Marquinhos Copacabana e Karla, Luana Bandeira, Mayombe Masai, G’leu Cambria, Os mais da Gafieira</p>
                    </div>
                </div>
                <!-- <a href="#lote" class="btn btn-success">Quero garantir minha vaga!</a> -->
            </div>
            <svg class="wave" viewBox="0 0 972 31">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Desktop" transform="translate(-26.000000, -284.000000)" fill="#FFFFFF">
                        <path d="M997.795825,315 L411.529732,315 L26.2041747,315 L26.2041747,284.13724 C87.0674583,302.180107 134.89703,311.20154 169.69289,311.20154 C221.225263,311.20154 277.011944,284.13724 337.052935,284.13724 C416.560926,284.13724 467.410067,311.20154 512,311.20154 C569.075502,311.20154 615.909439,284.13724 699.61076,284.13724 C751.462691,284.13724 804.80895,311.20154 856.660881,311.20154 C888.356275,311.20154 935.401256,302.180107 997.795825,284.13724 L997.795825,315 Z" id="Combined-Shape"></path>
                    </g>
                </g>
            </svg>
        </div>
    </section>
</template>

<script>

import VideoBg from 'vue-videobg'

import ImLogo2020 from '@/assets/img/logo/logo-sambamaniacos-2020.png'
import ImVideo from '@/assets/img/home/home.jpg'
import ImMobile from '@/assets/img/home/sambamaniacos-background.jpg'
import Video from '@/assets/video/video-banner-home.mp4'

export default {
    name: 'Video',
    components: {
        VideoBg
    },
    data: () => ({
        videomp4: Video,
        // videomp4: 'https://www.sambamaniacos.com.br/assets/videos/video-banner-home.mp4',
        imageSm2019: ImLogo2020,
        videoimage: ImVideo,
        lote: {}
    }),
    mounted: () => {
        if (window.innerWidth <= 767) {
            let bannerEl = document.getElementsByClassName('banner')
            if (bannerEl.length) {
                bannerEl[0].style.backgroundImage = 'url(' + ImMobile + ')'
            }
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/_mixin"

    #banner
        width: 100vw
        height: 100vh
        min-height: 750px
        background-position: top
        background-size: cover
        position: relative
        @include device(mobile)
            &
                height: 105vh
        .VideoBg
            height: 100%!important
        .body
            position: absolute
            top: 0
            left: 0
            right: 0
            bottom: 0
            padding-top: 90px

            background: -moz-linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 2%, rgba(0,0,0,0) 99%, rgba(0,0,0,0) 100%) /* FF3.6-15 */
            background: -webkit-linear-gradient(45deg, rgba(0,0,0,1) 0%,rgba(0,0,0,1) 2%,rgba(0,0,0,0) 99%,rgba(0,0,0,0) 100%) /* Chrome10-25,Safari5.1-6 */
            background: linear-gradient(45deg, rgba(0,0,0,1) 0%,rgba(0,0,0,1) 2%,rgba(0,0,0,0) 99%,rgba(0,0,0,0) 100%) /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#00000000',GradientType=1 ) /* IE6-9 fallback on horizontal gradient */

            display: flex
            align-items: center
            justify-content: center
            @include device(mobile)
                &
                    padding-top: 50px
            svg.wave
                width: 100%
                position: absolute
                bottom: 0
                z-index: 1
            .conteudo
                text-align: center
                z-index: 2
                @include device(mobile)
                    &
                        padding: 0 10px
                @include device(desktop)
                    &
                        bottom: 200px
                .atracoes
                    display: flex
                    @include device(mobile)
                        &
                            flex-direction: column
                .logo-sm
                    margin: -40px 0 -20px
                    max-width: 480px
                    @include device(mobile)
                        &
                            width: 80%
                p
                    color: white
                    &:not(.titulo)
                        font-size: 21px
                        max-width: 390px
                        line-height: 1.2
                        @include device(mobile)
                            &
                                font-size: 18px
                                line-height: 1.3
                    &.titulo
                        padding: 0
                        font-size: 40px
                        font-weight: 900
                        line-height: 1
                        margin: 10px auto
                        @include device(mobile)
                            &
                                font-size: 35px
                    &.texto
                        max-width: 490px
                        font-size: 22px
                        line-height: 1.3
                        @include device(mobile)
                            &
                                font-size: 20px

                .btn
                    margin-top: 5px
                    max-width: 270px
                    height: 60px
                    margin: 0 auto
                    font-size: 18px
                    border-radius: 150px
                .btn-bailes
                    color: white
                    margin-top: 10px
                    &:hover,
                    &:active
                        color: white

                .regressivo
                    > p
                        color: white
                        font-size: 14px
                        margin: 15px 0 0
                    span
                        color: white
                        margin-bottom: 17px
                    > div
                        display: flex
                        align-items: center
                        justify-content: center
                        > div
                            padding: 0 5px
                            text-align: center
                            p
                                margin: 0
                                font-size: 22px
                                line-height: 1
                            p:last-of-type
                                font-size: 16px

        @include device(desktop)
            &
                background: none
        @include device(laptops)
            &
                background: none
        @include device(tablets-portrait)
            &
                background: none

        @include device(mobile)
            .VideoBg
                display: none!important

</style>
